
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ISHADECOLOR, IOperateBtn } from '@/types/base.d';

@Component({
  name: 'btn',
})
export default class OperateBtn extends Vue {
  @Prop({
    required: true,
  }) btn!: IOperateBtn;

  @Prop({
    required: true,
  }) shadeColor!: ISHADECOLOR;
}
